export default __webpack_public_path__ + "static/media/largeaccuracypot.20bb2274.PNG";